import type {IFaq, IFaqQuestion} from "@pg-mono/faq";

import {
    type ILocationGenericParagraphList,
    type ILocationGenericParagraphSingleText,
    type ILocationGenericParagraphText,
    type ILocationGenericSection,
    ParagraphType,
    TextType
} from "./constants";

const escapeHtml = (value: string): string => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const singleTextToPlain = (single: ILocationGenericParagraphSingleText): string => {
    if (typeof single === "string") {
        return single;
    }
    if (single.type === TextType.LINK) {
        return single.text;
    }
    return "";
};

const textParagraphToPlain = (text: ILocationGenericParagraphText["text"]): string =>
    Array.isArray(text) ? text.map(singleTextToPlain).join("") : singleTextToPlain(text);

const singleTextToHtml = (single: ILocationGenericParagraphSingleText): string => {
    if (typeof single === "string") {
        return escapeHtml(single);
    }
    if (single.type === TextType.LINK) {
        return `<a href="${escapeHtml(single.href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(single.text)}</a>`;
    }
    return "";
};

const textParagraphToHtml = (text: ILocationGenericParagraphText["text"]): string => {
    const inner = Array.isArray(text) ? text.map(singleTextToHtml).join("") : singleTextToHtml(text);
    return `<p>${inner}</p>`;
};

const listParagraphToHtml = (paragraph: ILocationGenericParagraphList): string =>
    `<ul>${paragraph.text.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul>`;

const listParagraphToPlain = (paragraph: ILocationGenericParagraphList): string => paragraph.text.join(". ");

const sectionToFaqQuestion = (section: ILocationGenericSection): IFaqQuestion => {
    const htmlParts: string[] = [];
    const textParts: string[] = [];

    for (const paragraph of section.paragraphs) {
        if (paragraph.type === ParagraphType.TEXT) {
            htmlParts.push(textParagraphToHtml(paragraph.text));
            textParts.push(textParagraphToPlain(paragraph.text));
        } else if (paragraph.type === ParagraphType.LIST) {
            htmlParts.push(listParagraphToHtml(paragraph));
            textParts.push(listParagraphToPlain(paragraph));
        }
    }

    return {
        name: section.headline,
        answer: htmlParts.join(""),
        answer_text: textParts.join(" ").replace(/\s+/g, " ").trim()
    };
};

/** Maps `ILocationGenericSection[]` (kawalerki, mieszkania 2–4 pokoje, itd.) into `IFaq` for `FaqSection` / JSON-LD. */
export const locationGenericSectionsToFaqContent = (sections: ILocationGenericSection[]): IFaq | null => {
    if (sections.length === 0) {
        return null;
    }

    const [first, ...rest] = sections;
    const isIntroOnly = first.paragraphs.length === 0;
    const title = isIntroOnly ? first.headline : "Często zadawane pytania";
    const questionSections = isIntroOnly ? rest : sections;
    const questions = questionSections.filter((s) => s.paragraphs.length > 0).map(sectionToFaqQuestion);

    if (questions.length === 0) {
        return null;
    }

    return {title, questions};
};
import type {IFaq, IFaqQuestion} from "@pg-mono/faq";

import {
    type ILocationGenericParagraphList,
    type ILocationGenericParagraphSingleText,
    type ILocationGenericParagraphText,
    type ILocationGenericSection,
    ParagraphType,
    TextType
} from "./constants";

const escapeHtml = (value: string): string => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const singleTextToPlain = (single: ILocationGenericParagraphSingleText): string => {
    if (typeof single === "string") {
        return single;
    }
    if (single.type === TextType.LINK) {
        return single.text;
    }
    return "";
};

const textParagraphToPlain = (text: ILocationGenericParagraphText["text"]): string =>
    Array.isArray(text) ? text.map(singleTextToPlain).join("") : singleTextToPlain(text);

const singleTextToHtml = (single: ILocationGenericParagraphSingleText): string => {
    if (typeof single === "string") {
        return escapeHtml(single);
    }
    if (single.type === TextType.LINK) {
        return `<a href="${escapeHtml(single.href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(single.text)}</a>`;
    }
    return "";
};

const textParagraphToHtml = (text: ILocationGenericParagraphText["text"]): string => {
    const inner = Array.isArray(text) ? text.map(singleTextToHtml).join("") : singleTextToHtml(text);
    return `<p>${inner}</p>`;
};

const listParagraphToHtml = (paragraph: ILocationGenericParagraphList): string =>
    `<ul>${paragraph.text.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul>`;

const listParagraphToPlain = (paragraph: ILocationGenericParagraphList): string => paragraph.text.join(". ");

const sectionToFaqQuestion = (section: ILocationGenericSection): IFaqQuestion => {
    const htmlParts: string[] = [];
    const textParts: string[] = [];

    for (const paragraph of section.paragraphs) {
        if (paragraph.type === ParagraphType.TEXT) {
            htmlParts.push(textParagraphToHtml(paragraph.text));
            textParts.push(textParagraphToPlain(paragraph.text));
        } else if (paragraph.type === ParagraphType.LIST) {
            htmlParts.push(listParagraphToHtml(paragraph));
            textParts.push(listParagraphToPlain(paragraph));
        }
    }

    return {
        name: section.headline,
        answer: htmlParts.join(""),
        answer_text: textParts.join(" ").replace(/\s+/g, " ").trim()
    };
};

/** Maps `ILocationGenericSection[]` (kawalerki, mieszkania 2–4 pokoje, itd.) into `IFaq` for `FaqSection` / JSON-LD. */
export const locationGenericSectionsToFaqContent = (sections: ILocationGenericSection[]): IFaq | null => {
    if (sections.length === 0) {
        return null;
    }

    const [first, ...rest] = sections;
    const isIntroOnly = first.paragraphs.length === 0;
    const title = isIntroOnly ? first.headline : "Często zadawane pytania";
    const questionSections = isIntroOnly ? rest : sections;
    const questions = questionSections.filter((s) => s.paragraphs.length > 0).map(sectionToFaqQuestion);

    if (questions.length === 0) {
        return null;
    }

    return {title, questions};
};
